import { useTranslation } from 'react-i18next';

import { useRouteLoaderData } from '@remix-run/react';

import type { loader as communityLoader } from '~/routes/community';

export const useDirectoryName = (): string => {
  const { t } = useTranslation();
  const layoutData = useRouteLoaderData<typeof communityLoader>('routes/community');

  return layoutData?.community?.directory_name?.trim() || t('community.sidebar.members');
};
